import axios from 'axios';
import { RepositoryFactory } from 'shared/repositories/RepositoryFactory'

const HikingTrailsRepository = RepositoryFactory.get('hiking-trails');

const state = {
  filters: [],
  trails: {},
  trail: {},
  tooltip: {
    visible: false,
    coordinates: null,
    poi: null
  },
  bounds: null
}

const actions = {
  getFilterOptions ({ commit }) {
    return new Promise((resolve, reject) => {
      const filterOptions = ['distance', 'duration', 'entrance'];
      const requests = [];

      // Create multiple axios get requests and store in an Array..
      filterOptions.forEach((option) => requests.push(HikingTrailsRepository.getFilterOptions(option)))

      // Call axios all to handle all requests
      axios.all(requests).then(axios.spread((...responses) => {
        const data = [];

        // Iterate all responses and push to data Array...
        responses.forEach((response, index) => {
          if (response.status === 200 && response.data.data) {
            const filterOption = {
              type: filterOptions[index],
              options: response.data.data
            };

            data.push(filterOption)
          }
        });

        commit('SET_FILTERS', data);
        resolve(data);
      }))
        .catch(error => reject(error));
    });
  },
  getHikingTrails ({ commit }, queryParams) {
    return new Promise((resolve, reject) => {
      HikingTrailsRepository.getHikingTrails(queryParams).then((result) => {
        commit('SET_TRAILS', result.data);
        resolve(result.data)
      }).catch((error) => {
        reject(error)
      })
    });
  },
  getHikingTrail ({ commit }, queryParams) {
    return new Promise((resolve, reject) => {
      const slug = queryParams.slug;
      const params = { ...queryParams }

      delete params.slug;

      HikingTrailsRepository.getHikingTrail(slug, params).then((result) => {
        const trail = result.data;

        commit('SET_TRAIL', trail);
        resolve(result.data)
      }).catch((error) => {
        reject(error)
      })
    });
  },
  setMarkerPoiTooltip ({ commit }, tooltip) {
    commit('SET_MARKER_POI_TOOLTIP', tooltip);
  },
  storeBounds ({ commit }, bounds) {
    commit('SET_BOUNDS', bounds);
  }
}

const mutations = {
  SET_FILTERS (state, filters) {
    state.filters = filters;
  },
  SET_TRAILS (state, trails) {
    state.trails = trails;
  },
  SET_TRAIL (state, trail) {
    state.trail = trail;
  },
  SET_MARKER_POI_TOOLTIP (state, tooltip) {
    state.tooltip = tooltip;
  },
  SET_BOUNDS (state, bounds) {
    state.bounds = bounds
  }
}

const getters = {
  getFilters: state => state.filters,
  getTrails: state => state.trails,
  getTrail: state => state.trail,
  getTrailPois: state => {
    const pois = state.trail.pois && state.trail.pois.length ? state.trail.pois : [];
    return pois.filter(poi => poi.geo_lat && poi.geo_lng)
  },
  getPoiTooltip: state => state.tooltip,
  getBounds: state => state.bounds
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
